import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgNote = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#919499">
      <path d="M1 13h6.462L13 7.462V1H1z" />
      <path d="M7 13V7h6" />
    </g>
  </svg>
);
const Memo = memo(SvgNote);
export default Memo;
